import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BodyTypes, GalleryItems } from 'src/app/helpers';
import { GalleryService } from 'src/app/services/gallery/gallery.service';
import { LocaleService } from 'src/app/services/locale/locale.service';
import { RatingService } from 'src/app/services/rating/rating.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { PublicReportService } from 'src/app/services/public-report/public-report.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  public loaded: boolean = false;
  public vehicleBodyTypes: object = {
    bus: BodyTypes.bus,
    suv: BodyTypes.suv,
    sedan: BodyTypes.sedan,
    truckDouble: BodyTypes.truckDouble,
    truckSingle: BodyTypes.truckSingle,
    cargo: BodyTypes.cargo
  };
  public lang: string = null;

  public vinInfo: object = null;
  public information: object[] = [];

  public details: object[] = [];
  public flags: string[] = [];
  public options: object[] = [];
  public galleryData: object[] = [];
  public ratings: object = {};

  public mainImage: string = null;
  public calculatedScore: string | number = null;
  public PerceivedScore: string | number = null;

  public main: Object[] = [];

  public subscriptions: Subscription[] = [];
  public reportInfo: any;
  public accessToken: any;
  public accessvehicleId: any;
  public accessRole: any;
  public accessdata: object = {};
  public getaccessdata: object = {};

  public marketValueChecked: boolean = false;
  public purchaseValueChecked: boolean = false;
  public totalRepairCostChecked: boolean = false;
  publicToken = '';
  // Copy Button
  private $copyBtnLabel = new BehaviorSubject('Copy Link');
  copyBtnLabel = this.$copyBtnLabel.asObservable();

  constructor(
    public sharedService: SharedService,
    public ratingService: RatingService,
    public userService: UserService,
    public galleryService: GalleryService,
    public localeService: LocaleService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private route: ActivatedRoute,
    private publicReportService: PublicReportService
  ) {
    try {
      this.hasVinInfo = false;

      if (
        (this.activatedRoute.snapshot.queryParams.access_token &&
          this.activatedRoute.snapshot.queryParams.vehicle_id &&
          this.activatedRoute.snapshot.queryParams.role) ||
        this.activatedRoute.snapshot.queryParams.p ||
        this.activatedRoute.snapshot.queryParams.id
      ) {
        this.sharedService.setQueryParamCheck = true;

        if (
          this.activatedRoute.snapshot.queryParams.p ||
          this.activatedRoute.snapshot.queryParams.id
        ) {
          this.authService.publicToken =
            this.activatedRoute.snapshot.queryParams.p ||
            this.activatedRoute.snapshot.queryParams.id;
        }

        const data = {
          token: this.activatedRoute.snapshot.queryParams.access_token,
          vehicleid: this.activatedRoute.snapshot.queryParams.vehicle_id,
          user: {
            user_data: {
              role: this.activatedRoute.snapshot.queryParams.role
            }
          }
        };

        this.accessdata = data;

        if (Object.keys(this.accessdata).length) {
          this.authService.userSubject.next(this.accessdata);
          localStorage.setItem('user', JSON.stringify(this.accessdata));
          this.sharedService.setVehicleId = this.activatedRoute.snapshot.queryParams.vehicle_id;
        }
        this.getaccessdata = JSON.parse(localStorage.getItem('user') as any);
      }

      // this.getVinDetails();
      // this.allConditions();
      // this.getPlaceholderData();
      this.authService.publicTokenObs.subscribe((token) => {
        this.publicToken = token;
      });
    } catch (err) {
      console.log(err, 'con error');
    }
  }

  public hasVinInfo = false;
  ngOnInit(): void {
    this.hasVinInfo = false;

    try {
      let vinInfo = setInterval(() => {
        const data = JSON.parse(localStorage.getItem('vinInfo'));
        if (
          data ||
          this.activatedRoute.snapshot.queryParams.p ||
          this.activatedRoute.snapshot.queryParams.id
        ) {
          this.vinInfo = data;
          this.getVinDetails();
          this.allConditions();
          this.getPlaceholderData();
          if (data) this.mainParts('Exterior');
          clearInterval(vinInfo);
          if (data) this.hasVinInfo = true;
          if (
            this.activatedRoute.snapshot.queryParams.access_token &&
            this.activatedRoute.snapshot.queryParams.role
          ) {
            localStorage.removeItem('vinInfo');
          }
        }
      }, 1000);
    } catch (err) {
      console.log(err, 'report ngOnIit');
    }

    this.localeService.localeSubject.subscribe((res) => {
      this.lang = res;
    });

    this.sharedService.vinInformation.subscribe((res) => {
      res ? (this.vinInfo = res) : (this.vinInfo = null);
      if (res) {
        this.hasVinInfo = true;
        this.mainParts('Exterior');
      }
    });

    this.mainParts('Exterior');
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }

  getVinDetails() {
    let vehicleId: object = {};
    if (this.sharedService.getVehicleId) {
      vehicleId = {
        vehicle_id: this.sharedService.getVehicleId
      };
    } else {
      let vehiId: any = this.getaccessdata;
      vehicleId = {
        vehicle_id: vehiId.vehicleid
      };
    }

    const informationPublic = this.publicReportService.GetVinInfo(
      this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
    );

    let informationPublicSub: Subscription;

    const informationSub = this.userService
      .GetVinInfo(
        vehicleId,
        this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
      )
      .subscribe(
        (res) => {
          let success = res?.['success'];

          if (success) {
            console.log(success, 'success');
            let data = res['data'];

            this.information =
              data &&
              Object.keys(data ?? {}) &&
              data?.['vehicle_information'] &&
              Object.keys(data?.['vehicle_information'] ?? {})
                ? data?.['vehicle_information']
                : {};
            this.calculatedScore = this.information['calculated_value'];
            this.PerceivedScore = this.information['perceived_value'];
            this.details =
              data && Object.keys(data) && Object.keys(data['vehicle_details'])
                ? data['vehicle_details']
                : {};
            this.options =
              data && Object.keys(data ?? {}) && Object.keys(data['vehicle_options_data'] ?? {})
                ? data?.['vehicle_options_data']?.['options']
                : {};
            const flagsAll =
              data && Object.keys(data) && Object.keys(data['vehicle_flags_data'] ?? {})
                ? data?.['vehicle_flags_data']?.['flags']
                : {};

            for (const key in flagsAll) {
              if (Object.prototype.hasOwnProperty.call(flagsAll, key)) {
                if (flagsAll[key]) {
                  if (this.flags.indexOf(key.replace(new RegExp('_', 'g'), ' ')) === -1) {
                    this.flags.push(key.replace(new RegExp('_', 'g'), ' '));
                  }
                }
              }
            }

            if (
              this.activatedRoute.snapshot.queryParams.p ||
              this.activatedRoute.snapshot.queryParams.id
            ) {
              informationPublicSub = informationPublic.subscribe((res) => {
                let vinInfo = {};

                Object.entries(res['vinInfo'] ?? {})?.map(([key, value]) => {
                  vinInfo = {
                    ...vinInfo,
                    [key]: value
                  };
                });

                this.sharedService.setVinInfo = vinInfo;
              });
            }
          }
        },
        (error) => {}
      );
    this.subscriptions.push(informationSub, informationPublicSub);
  }

  mainParts(type: string) {
    try {
      let data: MainParts = {
        body_type_id: this.vinInfo?.['body_type_id']?.id,
        parts_condition_type: type,
        parent_id: null
      };

      this.loaded = true;
      this.ratingService
        .getPartsCondition(
          data,
          this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
        )
        .subscribe(
          (res) => {
            let success: boolean = res?.['success'];
            let data: Object = res?.['data'];

            if (success) {
              this.loaded = false;
              this.main = data['ratings'];
            }
          },
          (error) => {
            this.loaded = false;
          }
        );
    } catch (err) {
      console.log(err, 'mainParts error');
    }
  }

  allConditions() {
    let data: object = {};
    if (this.sharedService.getVehicleId) {
      data = {
        vehicle_id: this.sharedService.getVehicleId
      };
    } else {
      let vehiId: any = JSON.parse(localStorage.getItem('user') as any);
      data = {
        vehicle_id: vehiId?.vehicleid || this.accessdata['vehicleid']
      };
    }

    this.ratingService
      .getAllConditions(
        data,
        this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
      )
      .subscribe(
        (res) => {
          let success: boolean = res?.['success'];
          if (success) {
            let data: object = res['data'];

            Object.assign(this.ratings, {
              market_value: data['market_value'] || 'N/A',
              purchase_value: data['purchase_value'] || 'N/A',
              total_repair_cost: data['total_repair_cost'] || 'N/A',
              exterior: data['exterior'],
              interior: data['interior'],
              mechanics: data['mechanics'],
              frame: data['frame'],
              major_options: data['major_options']
            });
          }
        },
        (error) => {}
      );
  }

  getPlaceholderData() {
    let getPlaceholderSub = this.galleryService
      .getGalleryPlaceholder(
        this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
      )
      .subscribe(
        (res) => {
          let success: boolean = res['success'];
          let data: Object[] = res['data']['gallerys'];
          let url: string = res['data']['url'];

          if (success) {
            const allItems = data.map((item: any) => ({
              gallery_id: item.gallery_id,
              gallery_name: item.gallery_name,
              gallery_name_arabic: item.gallery_name_arabic,
              gallery_placeholder: `${url}/${item.gallery_placeholder}`,
              isImage: false
            }));

            // this.sharedService.setGallerySubmission = this.allItems;
            this.getGalleryData(allItems);
          }
        },
        (error) => {}
      );
    this.subscriptions.push(getPlaceholderSub);
  }

  getGalleryData(placeholders: Record<string, any>[]) {
    let vehiId: any = JSON.parse(localStorage.getItem('user') as any);
    let vehicleId: any;
    // let vehicleId: string = this.sharedService.getVehicleId;
    if (this.sharedService.getVehicleId) {
      vehicleId = this.sharedService.getVehicleId;
    } else {
      vehicleId = vehiId.vehicleid;
    }

    let getGallerySub = this.galleryService
      .getGallery(
        vehicleId,
        this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id
      )
      .subscribe(
        (res) => {
          let success: boolean = res['success'];
          if (success) {
            try {
              let data: object = JSON.parse(
                res['data']['vehicle_gallery_data'] || res['data']['vehicle_auction_data']
              );

              let gallery: Record<string, any>[] = data ? data['parts_images'] : null;
              let url: string = `${environment().base_path}storage/${this.activatedRoute.snapshot.queryParams.p || this.activatedRoute.snapshot.queryParams.id ? 'auction' : 'gallery'}/images/`;
              if (gallery) {
                for (const placeholder of placeholders) {
                  for (const item of gallery) {
                    if (placeholder.gallery_id === item.part_id) {
                      if (item['part_name'] === 'Front') this.mainImage = `${url}${item['image']}`;

                      this.galleryData.push({
                        ...placeholder,
                        image: `${url}${item['image']}`
                      });
                    }
                  }
                }
              }
            } catch (err) {
              console.log(err, 'getGallerySub');
            }
          }
        },
        (error) => {
          console.log(error, 'getGallerySub error');
        }
      );
    this.subscriptions.push(getGallerySub);
  }

  dataTypeChecker(data: any) {
    switch (typeof data) {
      case 'string':
        return 'string';

      case 'object':
        return 'object';

      default:
        return undefined;
    }
  }

  handleMarketValueCheck(event: Event) {
    this.marketValueChecked = (event.target as HTMLInputElement).checked;
  }

  handlePurchaseValueCheck(event: Event) {
    this.purchaseValueChecked = (event.target as HTMLInputElement).checked;
  }

  handleTotalRepairCostCheck(event: Event) {
    this.totalRepairCostChecked = (event.target as HTMLInputElement).checked;
  }

  print() {
    window.print();
  }

  copyReportUrl(event: Event) {
    (async () => {
      await navigator.clipboard.writeText(
        `${window.location.href}?id=${this.publicToken ?? this.authService.publicToken}`
      );
    })();
    const copyBtn = event.currentTarget as HTMLButtonElement;
    const icon = copyBtn.querySelector('.copy-icon');
    const text = copyBtn.querySelector('.copy-text');

    copyBtn.classList.add('copied');
    icon.textContent = '✓';
    text.textContent = 'Copied!';

    setTimeout(() => {
      copyBtn.classList.remove('copied');
      icon.textContent = '📋';
      text.textContent = 'Copy';
    }, 1500);
  }
}

interface MainParts {
  body_type_id: string;
  parts_condition_type: string;
  parent_id?: string;
}
